module.exports = __webpack_public_path__ + "media/src/images/icons/clock-4c351e50f9549527da5003494cf38707.svg";